export default function toSexAbbreviation(word) {
    if (word === "Laki-laki") return "L/M";
    return "P/F";
}
